/**
 * Localization messages for ActivateRoleModal component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Modal title
  'Save and Activate Role': 'roleRecs.activateRoleModal.title',

  // Modal description
  'Please provide the details below to save and activate the role':
    'roleRecs.activateRoleModal.description',

  // Form labels
  'Role Name': 'roleRecs.activateRoleModal.form.roleNameLabel',

  // Form placeholders
  'Give this role a unique name':
    'roleRecs.activateRoleModal.form.roleNamePlaceholder',
  'Provide a brief description for your role':
    'roleRecs.activateRoleModal.form.descriptionPlaceholder',

  // Advanced Options
  Requestable: 'roleRecs.activateRoleModal.advancedOptions.requestableLabel',
  'Enable this option to allow users to request this role':
    'roleRecs.activateRoleModal.advancedOptions.requestableTooltip',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type ActivateRoleModalMessage = keyof typeof invertedMessages;

export default invertedMessages;
